// =============================================================
// ⌨️ TypingIndicatorFeed.jsx — Indicadores de digitação ao vivo
// =============================================================

import React, { useEffect, useState } from "react";
import { listenAllSessions } from "../../../services/iaDashboard/sessionsService";

export default function TypingIndicatorFeed() {
  const [typingList, setTypingList] = useState([]);

  useEffect(() => {
    const unsub = listenAllSessions((sessions) => {
      const typingUsers = sessions.filter((s) => s.isTyping === true);
      setTypingList(typingUsers);
    });

    return () => unsub && unsub();
  }, []);

  return (
    <div className="ia-realtime-box">
      <h3 className="ia-dashboard-panel-title">⌨️ Digitação em tempo real</h3>

      {typingList.length === 0 && (
        <p className="ia-realtime-empty">Nenhum usuário digitando.</p>
      )}

      {typingList.map((s) => (
        <div key={s.id} className="ia-realtime-feed-item">
          <strong>{s.usuarioNome || "Usuário"}</strong>{" "}
          <span className="ia-typing-dot">● digitando…</span>
        </div>
      ))}
    </div>
  );
}
